import { ComponentProps } from 'react';
import styles from './divider.module.scss';

import { Separator as BaseDivider } from '@base-ui/react/separator';

interface IDividerProps extends Omit<ComponentProps<typeof BaseDivider>, 'className'> {
  variant?: 'solid' | 'dashed';
  className?: string;
}

export const Divider = ({ className = '', variant = 'solid', ...props }: IDividerProps) => {
  return (
    <div className={className}>
      <BaseDivider {...props} className={styles.divider} data-variant={variant} />
    </div>
  );
};
